import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Paper,
  FormControlLabel,
  Checkbox,
  makeStyles,
} from "@material-ui/core";
import t from "../common/localization";
import {
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatDurationTime,
} from "../common/formatter";
import ReportFilter from "./ReportFilter";
import ReportLayoutPage from "./ReportLayoutPage";
import { useAttributePreference } from "../common/preferences";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";

const useStyles = makeStyles((theme) => ({
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 690,
  },
}));

const Filter = ({ setItems }) => {
  const dispatch = useDispatch();

  const handleSubmit = async (
    deviceId,
    groupId,
    from,
    to,
    mail,
    headers,
    onResponseGet
  ) => {
    const query = new URLSearchParams({ from, to, mail });
    let qString = query.toString();
    let deviceIdQuery = "";
    let groupIdQuery = "";

    deviceId.forEach((element) => {
      deviceIdQuery += `&deviceId=${element}`;
    });
    groupId.forEach((element) => {
      groupIdQuery += `&groupId=${element}`;
    });

    if (deviceIdQuery) {
      qString += deviceIdQuery;
    }
    if (groupIdQuery) {
      qString += groupIdQuery;
    }
    dispatch(showLoaderStateActions.addState(true));
    const response = await fetch(`/api/reports/acDuration?${qString}`, {
      headers,
    });
    onResponseGet(response);
    if (response.ok && response.headers.get("content-type")) {
      const contentType = response.headers.get("content-type");
      if (contentType === "application/pdf") {
        const name = "report.pdf";
        const blobUrl = URL.createObjectURL(await response.blob());
        // Create a link element
        const link = document.createElement("a");
        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = name;
        // Append link to the body
        document.body.appendChild(link);
        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        // Remove link from body
        document.body.removeChild(link);
        dispatch(showLoaderStateActions.addState(false));
      } else if (contentType === "application/json") {
        const resItem = await response.json();
        dispatch(showLoaderStateActions.addState(false));
        setItems(resItem);
      } else {
        dispatch(showLoaderStateActions.addState(false));
        window.location.assign(
          window.URL.createObjectURL(await response.blob())
        );
      }
    } else {
      dispatch(showLoaderStateActions.addState(false));
    }
  };

  return (
    <ReportFilter
      handleSubmit={handleSubmit}
      reportHeader="Ac Duration Report"
    />
  );
};

const columns = [
  { field: "deviceName", headerName: t("settingsVehicleNumber"), flex: 1 },
  { field: "startDate", headerName: t("reportStartDate"), flex: 1 },
  { field: "endDate", headerName: t("reportEndDate"), flex: 1 },
  { 
    field: "onDuration", 
    headerName: t("reportOnHours"),
    flex: 1,
    renderCell: (params) => formatDurationTime(params.value),
  },
  { 
    field: "offDuration", 
    headerName: t("reportOnHours"),
    flex: 1,
    renderCell: (params) => formatDurationTime(params.value),
  },
];

const AcDurationReportPage = () => {
  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const [items, setItems] = useState([]);
  const classes = useStyles();

  let mainData = [];
  const setRecursiveData = (newItems) => {
    setTimeout(() => {
      let hasMore = mainData.length + 1 < newItems.length;
      const list = newItems.slice(0, mainData.length + 1);
      mainData = list;
      setItems(list);
      if (hasMore) setRecursiveData(newItems);
    }, 0);
  };

  const setData = (newItems) => {
    mainData = [];
    setRecursiveData(newItems);
  };

  const gridRows = items.map((item, index) => ({
      id: index, // required unique id for DataGrid
      deviceName: item.deviceName,
      startTime: formatDate(item.startTime, "MMM D, hh:mm A"),
      endTime: formatDate(item.endTime, "MMM D, hh:mm A"),
      onDuration: item.onDuration,
      offDuration: item.offDuration,
    }));

  return (
    <ReportLayoutPage filter={<Filter setItems={setData} />}>
      {/* <TableContainer className={classes.tContainer} component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{ backgroundColor: "#361DDB" }}>
            <TableRow>
              <TableCell className={classes.tCell}>
                {t("settingsVehicleNumber")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportStartDate")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportEndDate")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportOnHours")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportOffHours")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>{<b>{item.deviceName}</b>}</TableCell>
                <TableCell>
                  {formatDate(item.startTime, "MMM D, hh:mm A")}
                </TableCell>
                <TableCell>
                  {formatDate(item.endTime, "MMM D, hh:mm A")}
                </TableCell>
                <TableCell>{formatDurationTime(item.onDuration)}</TableCell>
                <TableCell>{formatDurationTime(item.offDuration)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}

      <DataGrid
        rows={gridRows}
        columns={columns}
        disableSelectionOnClick
        autoHeight={false}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        pagination
      />
    </ReportLayoutPage>
  );
};

export default AcDurationReportPage;
